/* ESENEA MASTER LANDING V1 — comportamiento mínimo (vídeo bajo demanda, galería, compra directa). Sin dependencias. */
(function () {
  if (window.__eseneaPdp) return;
  window.__eseneaPdp = true;

  /* 1) Vídeo con "facade": no se descarga hasta pulsar y NUNCA arranca solo. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-esenea-play]');
    if (!btn) return;
    var box = btn.closest('[data-esenea-video]');
    var tpl = box && box.querySelector('template');
    if (!tpl) return;
    var frag = tpl.content.cloneNode(true);
    var v = frag.querySelector('video');
    var c = navigator.connection;
    if (v && c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) {
      var low = v.getAttribute('data-low');
      var s = v.querySelector('source');
      if (low && s) s.src = low;
    }
    box.innerHTML = '';
    box.appendChild(frag);
    box.classList.add('is-playing');
    v = box.querySelector('video');
    if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  });

  /* 2) Galería: miniaturas/puntos <-> scroll con snap. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-eg-thumb]');
    if (!t) return;
    var g = t.closest('[data-esenea-gallery]');
    var track = g && g.querySelector('.eg__track');
    var slide = track && track.children[parseInt(t.getAttribute('data-eg-thumb'), 10)];
    if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  });
  var ticking = false;
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.classList || !track.classList.contains('eg__track') || ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      var g = track.closest('[data-esenea-gallery]');
      if (!g) return;
      [].forEach.call(g.querySelectorAll('[data-eg-thumb]'), function (b) {
        b.setAttribute('aria-current', String(parseInt(b.getAttribute('data-eg-thumb'), 10) === i));
      });
    });
  }, true);

  /* 3) Comprar ahora: mismo flujo nativo de Shopify (POST /cart/add + redirección al checkout).
        Solo sincroniza cantidad y variante con lo elegido en la ficha. */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-esenea-buynow]');
    if (!f) return;
    var root = document.querySelector('.product-information') || document;
    var q = root.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]');
    if (q && q.value) f.querySelector('input[name="quantity"]').value = q.value;
    var v = new URLSearchParams(location.search).get('variant');
    if (v) f.querySelector('input[name="id"]').value = v;
  });
})();